module.exports = ['$compile', '$rootScope', function ($compile, $rootScope) {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            $rootScope.$watch('directives', function (newVal, oldVal) {
                "use strict";
                console.log('watch', newVal, oldVal);
                console.log(elem)
                elem.html('');

                newVal.forEach(function (item) {
                    var ns = scope.$new();
                    // if (item.scope) {
                    //     item.scope.$destroy();
                    // }
                    // item.scope = $rootScope.$new();
                    angular.extend(ns, item.data);
                    elem.append($compile(item.html)(ns));
                    console.log('compilato')
                });

            },true)
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/directives/directiveInjector/directiveInjector.js
// module id = 313
// module chunks = 0